import { Address, zeroAddress } from 'viem'
import { ChainId, ERC20Token, Native } from '@pancakeswap/sdk'

export const createCurrentcy = (chainId: number, address: Address) => {
  if (address === zeroAddress) {
    return Native.onChain(chainId)
  }

  return new ERC20Token(chainId, address, 18, '', '', '')
}
